<div [ngClass]="this.menuService.menuOptions['tools'] ? 'active' : ''" class="tools-menu">
  <div>
    <h1>Tools</h1>
    <ul>
<!--      <ng-template [access]="0">
        <h4>NavAid</h4>
        <app-menu-option
          [action]="this.openCoverageAssessmentTool.bind(this)"
          [label]="'Coverage Assessment Tool'">
        </app-menu-option>
        <app-menu-option
          [action]="this.openFomCheck.bind(this)"
          [label]="'ARINC FOM Check'">
        </app-menu-option>
        <app-menu-option
          [action]="this.showCriticalNavaids.bind(this)"
          [label]="'Show Critical NavAids'">
        </app-menu-option>
        <app-menu-option
          [action]="this.openDocAndSectorizationDisplay.bind(this)"
          [label]="'DOC and Sectorization Display'">
        </app-menu-option>
        <app-menu-option
          [action]="this.tabsService.openNewNavaidsCoChannelCheck.bind(tabsService)"
          [label]="'Co-Channel Check'">
        </app-menu-option>
        <app-menu-option
          [action]="this.menuService.sitingToolService.sitingToolAreaInitialization.bind(this, 'Polygon')"
          [label]="'NavAid Siting Tool - define area by Polygon'">
        </app-menu-option>
        <app-menu-option
          [action]="this.menuService.sitingToolService.sitingToolAreaInitialization.bind(this, 'Circle')"
          [label]="'NavAid Siting Tool - define area by Circle'">
        </app-menu-option>
        <app-menu-option
          [action]="this.menuService.sitingToolService.sitingToolAreaInitialization.bind(this, 'Freehand')"
          [label]="'NavAid Siting Tool - define area by Freehand'">
        </app-menu-option>
        <h4>Flight Inspection</h4>
        <app-menu-option
          [action]="this.importService.showMesssageModal.bind(importService, 'Flight Inspection Processing Tool', this.processingToolFormats)"
          [label]="'FI Processing Tool'">
        </app-menu-option>
      </ng-template>-->

<!--      <h4 [access]="0">Others</h4>-->
       <app-menu-option
          [action]="this.openCoverageAssessmentTool.bind(this)"
          [label]="'Coverage Assessment Tool'">
        </app-menu-option>
      <app-menu-option
        [action]="this.openAltitudeFilter.bind(this)"
        [label]="'Altitude Filter'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openAzimuthTool.bind(this)"
        [label]="'Azimuth Tool'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openBarometricToolController.bind(this)"
        [label]="'Barometric Calculation Tool'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openCrossSection.bind(this)"
        [label]="'Cross Section'">
      </app-menu-option>
      <app-menu-option
        [action]="this.distanceAndAzimuth.bind(this)"
        [label]="'Distance and Azimuth'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openHorizonTools.bind(this)"
        [label]="'Horizon Tool'">
      </app-menu-option>
      <app-menu-option
        [action]="this.activateIdentifyTool.bind(this)"
        [label]="'Identify Tool'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openMapSearch.bind(this)"
        [label]="'Map Search'">
      </app-menu-option>
<!--      <app-menu-option [access]="0"
        [action]="this.openMultipathTool.bind(this)"
        [label]="'Multipath Tool'">
      </app-menu-option>-->
      <!--<app-menu-option >Open Log Viewer</app-menu-option>-->
      <app-menu-option
        [action]="this.openRangeRingTool.bind(this)"
        [label]="'Range Ring Tool'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openTerrainAltitudeCut.bind(this)"
        [label]="'Terrain Altitude Cut'">
      </app-menu-option>
      <app-menu-option
        [action]="this.openTerrainGrid.bind(this)"
        [label]="'Terrain Grid'">
      </app-menu-option>
      <app-menu-option
        [action]="this.terrainHeighAtPoint.bind(this)"
        [label]="'Terrain Height at Point'">
      </app-menu-option>
      <app-menu-option
        [action]="this.activateWebBrowser.bind(this, 'Roadmap')"
        [label]="'Web Browser Map - Type Roadmap'">
      </app-menu-option>
      <app-menu-option
        [action]="this.activateWebBrowser.bind(this, 'Satellite')"
        [label]="'Web Browser Map - Type Satellite'">
      </app-menu-option>
      <!-- <app-menu-option
        [action]="this.openSelectionByFir.bind(this)"
        [label]="'Selection by FIR'">
      </app-menu-option> -->
    </ul>
  </div>
</div>
